
import { Link, useLocation } from 'react-router-dom';

const NavBarHeytelItems = ({ componentName, changeComponent }) => {
  const { pathname, search } = useLocation();
  const tikNumURL = new URLSearchParams(search).get("TikNum");
  const systemCodeURL = new URLSearchParams(search).get("SystemCode");

  const CustomItem = ({ name, children, ...props }) => {
    return (
      <li className={"navbar-item" + (componentName === name ? " active" : "")}>
        {/* <a className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</a> */}
        <Link to={`${pathname}?TikNum=${tikNumURL}&SystemCode=${systemCodeURL}&Page=${name}`} className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</Link>
      </li>
    )
  }
  
  return (
    <nav className="navbar">
      <div className="container">
        <ul className="navbar-tabs">
          <CustomItem name="ProcessInfo">תהליך טיפול בתיק</CustomItem>
        </ul>
      </div>
    </nav>
  )
}

export default NavBarHeytelItems;